import React from "react";
import {
    Radar,
    RadarChart as QRadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    ResponsiveContainer,
    Tooltip,
    LabelList,
} from "recharts";

export default function RadarChart(props) {
    const { name, width = 700, height = 700, data, color1 = "#2288bb" } = props;

    return (
        <ResponsiveContainer width={width} height={height}>
            <QRadarChart
                cx={"50%"}
                cy={"50%"}
                outerRadius={width / 4}
                width={width}
                height={height}
                data={data}
                margin={{ left: 100, right: 100 }}
            >
                <PolarGrid polarRadius={[0, 25, 50, 75, 100, 125]} />
                <PolarAngleAxis dataKey="competency" />
                <PolarRadiusAxis domain={[0, 5]} tickCount={5} />
                <Radar
                    name={name}
                    dataKey="value"
                    fill={color1}
                    fillOpacity={0.5}
                >
                    <LabelList
                        dataKey="value"
                        position="outsideTop"
                        offset={-150}
                        angle={0}
                        stroke="#000000"
                    />
                </Radar>
                <Tooltip />
            </QRadarChart>
        </ResponsiveContainer>
    );
}

// Data Format
// -------------------------------
/*
    <RadarChart
        width={240}
        height={240}
        data={[
            {
                name: "Score",
                axis: "Item1",
                value: 50,
            },
        ]}
    />
*/
